/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <RecyclerDataTable v-if="computedHeader.length" :headers="computedHeader" :items="tableData" :key_field="'sensor_time'" />
  </div>
</template>

<script>
import WSApi from "@/services/WeatherStation.js";

export default {
  props: ["date", "wsId", "plantId"],
  components: {
    'RecyclerDataTable': () =>
      import('@/components/utility/RecyclerDataTable.vue'),
  },
  data: () => ({
    tableData: [],
    headers: []
  }),
  computed: {
    isNowCallingApi() {
      return `${this.date.from} ${this.date.to} ${this.plantId} ${this.wsId}`;
    },
    computedHeader() {
      const cloneHeader = _.cloneDeep(this.headers);
      return cloneHeader.map((el) => {
        return {
          key: this.$t(el.text),
          value: el.value
        };
      });
    },
  },
  created() {
    this.getWsTableData();
  },
  methods: {
    async getWsTableData() {
      this.loading = true;
      const param = {
        plantId: this.plantId,
        dateFrom: this.date.from,
        dateTo: this.date.to,
        wsId: this.wsId,
      };
      let response = "";
      if (
        this.plantId === "114" ||
        this.plantId === "151" ||
        this.plantId === "159"
      ) {
        response = await WSApi.wsDataTableAll(param);
      } else {
        response = await WSApi.wsDataTable(param);
      }
      if (response.status === 200) {
        this.tableData = response.data.message.data;
        this.headers = response.data.message.headers;
      }
    },
  },
  watch: {
    isNowCallingApi() {
      this.getWsTableData();
    },
  },
};
</script>

<style scoped>
.dataWidth {
  min-width: 100px;
}

.header {
  height: 500px;
  overflow: auto;
}

.header th {
  z-index: 1 !important;
  position: sticky !important;
  top: 0 !important;
  color: var(--v-extraGrey) !important;
  background: var(--v-primary-base) !important;
}
</style>

<style>
.header .v-table__overflow {
  overflow: unset;
}
</style>
